var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfilePic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 14513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.35,
    d: "M20 42C31.0457 42 40 32.598 40 21C40 9.40202 31.0457 0 20 0C8.9543 0 0 9.40202 0 21C0 32.598 8.9543 42 20 42Z",
    fill: "#44DE94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 26C22.7614 26 25 23.7614 25 21C25 18.2386 22.7614 16 20 16C17.2386 16 15 18.2386 15 21C15 23.7614 17.2386 26 20 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.766 31.7464C31.148 29.5855 29.26 28 27 28H13C10.74 28 8.85201 29.5855 8.23401 31.7464C10.724 35.8057 15.058 38.5 20 38.5C24.942 38.5 29.276 35.8057 31.766 31.7464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 14352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.35,
    d: "M19.9466 4.18458C19.2234 4.02255 18.6798 4.22279 18.2425 4.5408C17.5723 3.65329 16.4054 3.2211 15.2757 3.55378C14.1461 3.88646 13.3997 4.88206 13.318 5.99099C12.7777 5.96144 12.2122 6.08728 11.6928 6.61525C11.158 7.1592 10.8801 7.9446 11.0573 8.68657C11.3514 9.92279 12.6161 10.6444 13.8191 10.2901L15.0622 14.5112L21.3939 12.6466L20.1508 8.42552C21.3538 8.07124 22.0256 6.77938 21.6034 5.58144C21.3502 4.86185 20.6909 4.35188 19.9466 4.18458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.6214 11.7273L15.1271 13.3453C14.7131 13.4672 14.4822 13.92 14.611 14.3574C14.7398 14.7948 15.1792 15.0501 15.5933 14.9282L21.0875 13.3102C21.5016 13.1883 21.7325 12.7355 21.6036 12.2981C21.4748 11.8607 21.0354 11.6054 20.6214 11.7273Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/profile-pic.61b36ed9e27f28d54cac1714bfaf871c.svg";
export { ForwardRef as ReactComponent };